<template>
  <v-container class="pa-0 ma-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <div class="pt-4">
      <v-card outlined>
        <!-- form  -->
        <v-card-text>
          <v-row class="ma-0">
            <!-- form  -->
            <v-col
              class="ma-0 pa-0 pr-2"
              style="border-right: 1px solid lightgray"
              cols="12"
              md="6"
            >
              <v-row class="mb-0 pb-0">
                <v-col class="pb-0" cols="12" md="12">
                  <el-autocomplete
                    required
                    :items="enumsClassifiers.dataVolumeOrderSav"
                    enums
                    itemvalue="value"
                    itemtext="text"
                    label="Duomenų apimtis"
                    tooltip="Vieša paieška. Paieška. Duomenų apimtis"
                    v-model="dataVolume"
                  />
                </v-col>
                <!-- toggle  -->
                <v-col style="overflow: auto" cols="12" md="12">
                  <v-btn-toggle
                    @change="searchByChange()"
                    mandatory
                    v-model="searchBy"
                  >
                    <v-btn
                      v-if="showFizToggle"
                      active-class="active-btn-group-item"
                      :class="getForAccessibility ? ' btn-for-disabled ' : ''"
                      small
                      value="FIZ"
                    >
                      <v-icon style="padding-right: 4px">mdi-account</v-icon>
                      <span>{{ $t('Fizinis asmuo') }}</span>
                    </v-btn>
                    <v-btn
                      v-if="showJurToggle"
                      active-class="active-btn-group-item"
                      :class="getForAccessibility ? ' btn-for-disabled ' : ''"
                      small
                      value="JUR"
                    >
                      <v-icon style="padding-right: 4px">mdi-bank</v-icon>
                      <span>{{ $t('Juridinis asmuo') }}</span>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>

                <!-- FIZ card  -->
                <template v-if="showFiz">
                  <v-col class="pb-0" cols="12" md="12" lg="6">
                    <el-text-field
                      required
                      label="Vardas"
                      tooltip="Vieša paieška. Paieška. Vardas"
                      v-model="formData.name"
                      validateKey="FIZ_name"
                      key="FIZ_name"
                      :maxlength="100"
                    />
                  </v-col>
                  <v-col class="pb-0" cols="12" md="12" lg="6">
                    <el-text-field
                      required
                      label="Pavardė"
                      tooltip="Vieša paieška. Paieška. Pavardė"
                      v-model="formData.lastname"
                      validateKey="FIZ_lastname"
                      key="FIZ_lastname"
                      :maxlength="100"
                    />
                  </v-col>
                  <v-col class="pt-0 pb-0" cols="12" >
                    <el-radio-group
                      class="mt-0 mb-4"
                      v-model="formData.searchType"
                      :items="searchType"
                      label="searchType"
                      required
                    >
                    </el-radio-group>
                  </v-col>
                  <template v-if="showSearchTypeCode">
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-text-field
                        required
                        label="Asmens kodas"
                        tooltip="Vieša paieška. Paieška. Asmens kodas"
                        v-model="formData.code"
                        validateKey="FIZ_code"
                        key="FIZ_code"
                        :cMask="11"
                        :length="11"
                      />
                    </v-col>

                  </template>
                  <template v-if="showSearchTypeIltuCode">
                    <v-col class="pb-0" cols="12" md="12" :lg="biggerIltu ? 8 : 6">
                      <el-text-field
                        required
                        label="ILTU kodas"
                        tooltip="Vieša paieška. Paieška. ILTU kodas"
                        v-model="formData.iltu_code"
                        validateKey="FIZ_iltu_code"
                        key="FIZ_iltu_code"
                        :maxlength="20"
                      />
                    </v-col>
                  </template>
                  <template v-if="showSearchTypedateAnd">
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-date-picker
                        required
                        label="Gimimo data"
                        pastDates
                        tooltip="Vieša paieška. Paieška. Gimimo data"
                        v-model="formData.birth_date"
                        validateKey="UZS_birth_date"
                        key="UZS_birth_date"
                      />
                    </v-col>
                    <!-- <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-autocomplete
                        required
                        :items="classifiers.country"
                        itemvalue="value"
                        itemtext="text"
                        label="Šalis"
                        tooltip="Vieša paieška. Paieška. Šalis"
                        v-model="formData.country"
                        validateKey="UZS_country"
                        key="UZS_country"
                      />
                    </v-col> -->
                  </template>
                   <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
                  <v-col class="pt-0 pb-0" cols="12" md="12">
                    <el-radio-group
                      class="mt-0 mb-4"
                      v-model="formData.parameterType"
                      :items="parameterType"
                      label="parameterType"
                      required
                    >
                    </el-radio-group>
                  </v-col>
                  <template v-if="showParameterTypeItpsi || showParameterTypeItpsp">
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-text-field
                        required
                        label="Identifikavimo kodas"
                        tooltip="Vieša paieška. Paieška. Identifikavimo kodas"
                        v-model="formData.mandate_code"
                        :cMask="10"
                        :length="10"
                        validateKey="FIZ_id_code"
                        key="FIZ_id_code"
                      />
                    </v-col>
                  </template>
                  <template v-if="showParameterTypeNtpi">
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-text-field
                        required
                        label="Įgaliojimo notarinio registro numeris"
                        tooltip="Vieša paieška. Paieška. Įgaliojimo notarinio registro numeris"
                        v-model="formData.notarial_code"
                        :maxlength="20"
                        validateKey="FIZ_nr_code"
                        key="FIZ_nr_code"
                      />
                    </v-col>
                  </template>
                   <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
                </template>
                <!-- JUR card  -->
                <template v-if="showJur">
                  <v-col class="pt-0 pb-0" cols="12" md="12">
                    <el-radio-group
                      class="mt-0 mb-4"
                      label="searchType"
                      v-model="formData.searchType"
                      :items="searchTypeJUR"
                      required
                    >
                    </el-radio-group>
                  </v-col>
                  <template v-if="formData.searchType === 'jar-code'">
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-text-field
                        required
                        label="Juridinio asmens kodas"
                        v-model="formData.code"
                        :cMask="9"
                        :length="9"
                        validateKey="JUR_code"
                        key="JUR_code"
                      />
                    </v-col>

                  </template>
                  <template
                    v-if="formData.searchType === 'jar-code-and-country'"
                  >
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-text-field
                        required
                        label="Juridinio asmens kodas"
                        v-model="formData.code"
                        :maxlength="20"
                        validateKey="JUR_code"
                        key="JUR_code"
                      />
                    </v-col>
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-autocomplete
                        required
                        :items="classifiers.country"
                        itemvalue="value"
                        itemtext="text"
                        label="Valstybė"
                        tooltip="Vieša paieška. Paieška. Valstybė"
                        v-model="formData.country"
                        validateKey="UZS_country"
                        key="UZS_country"
                      />
                    </v-col>
                  </template>
                   <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
                  <v-col class="pt-0 pb-0" cols="12" md="12">
                    <el-radio-group
                      class="mt-0 mb-4"
                      label="parameterType"
                      v-model="formData.parameterType"
                      :items="parameterType"
                      required
                    >
                    </el-radio-group>
                  </v-col>
                  <template v-if="showParameterTypeItpsi || showParameterTypeItpsp">
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-text-field
                        required
                        label="Identifikavimo kodas"
                        v-model="formData.mandate_code"
                        :cMask="10"
                        :length="10"
                        validateKey="FIZ_id_code"
                        key="FIZ_id_code"
                      />
                    </v-col>
                  </template>
                  <template v-if="formData.parameterType === 'NTPI'">
                    <v-col class="pb-0" cols="12" md="12" lg="6">
                      <el-text-field
                        required
                        label="Įgaliojimo notarinio registro numeris"
                        v-model="formData.notarial_code"
                        :maxlength="20"
                        validateKey="FIZ_nr_code"
                        key="FIZ_nr_code"
                      />
                    </v-col>
                  </template>
                   <v-col class="pt-0 pb-0" cols="12">
                <v-divider></v-divider>
              </v-col>
                </template>
                <template>
                  <v-col class="pt-4 pb-0" cols="12" md="6">
                    <el-autocomplete
                      required
                      :items="enumsClassifiers.docLanguage"
                      enums
                      itemvalue="value"
                      itemtext="text"
                      label="Išrašo dokumento kalba"
                      v-model="formData.docLanguage"
                    />
                  </v-col>
                  <v-col class="pb-0" cols="12" md="6"></v-col>
                  <v-col class="pb-0 pt-0" cols="12" md="12">
                    <v-divider></v-divider>
                  </v-col>
                </template>
                <!-- data -->
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-textarea
                    label="Duomenų naudojimo tikslas"
                    tooltip="Vieša paieška. Paieška. Duomenų naudojimo tikslas"
                    v-model="formData.purpose"
                    :maxlength="2000"
                    required
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-textarea
                    label="Teisinis pagrindas"
                    tooltip="Vieša paieška. Paieška. Teisinis pagrindas"
                    v-model="formData.legal_basic"
                    :maxlength="2000"
                    required
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-file-input
                    label="Duomenų naudojimo tikslo dokumentas"
                    v-model="files.purpose_file"
                    :fileData="formData.purpose_file"
                    :disabled="modeReadonly"
                    @addFile="addFile($event, 'purpose_file')"
                    @clearFile="clearFile($event, 'purpose_file')"
                  ></el-file-input>
                </v-col>
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-file-input
                    label="Teisinio pagrindo dokumentas"
                    v-model="files.legal_basis_file"
                    :fileData="formData.legal_basis_file"
                    :disabled="modeReadonly"
                    @addFile="addFile($event, 'legal_basis_file')"
                    @clearFile="clearFile($event, 'legal_basis_file')"
                  ></el-file-input>
                </v-col>
                <v-col class="pb-0" cols="12" md="12">
                  <el-autocomplete
                    required
                    :items="enumsClassifiers.withdrawalOrderPublic"
                    enums
                    itemvalue="value"
                    itemtext="text"
                    label="Atsiėmimo būdas"
                    tooltip="Vieša paieška. Paieška. Atsiėmimo būdas"
                    v-model="formData.withdrawal"
                  />
                </v-col>
              </v-row>
            </v-col>
            <!-- form  -->
            <v-col class="ma-0 pa-0 pl-2" cols="12" md="6">
              <v-row class="mb-0 pb-0">
                <v-col class="pb-0 mt-2 pb-7" cols="12" md="12">
                  <h2 class="ml-3 mb-2">{{ $t('Duomenų gavėjas') }}</h2>
                </v-col>
                <v-col style="overflow: auto" cols="12" md="12">
                  <v-btn-toggle mandatory v-model="recipient.person_type">
                    <v-btn
                      active-class="active-btn-group-item"
                      :class="getForAccessibility ? ' btn-for-disabled ' : ''"
                      small
                      value="FIZ"
                    >
                      <v-icon style="padding-right: 4px">mdi-account</v-icon>
                      <span>{{ $t('Fizinis asmuo') }}</span>
                    </v-btn>
                    <v-btn
                      active-class="active-btn-group-item"
                      :class="getForAccessibility ? ' btn-for-disabled ' : ''"
                      small
                      value="JUR"
                    >
                      <v-icon style="padding-right: 4px">mdi-bank</v-icon>
                      <span>{{ $t('Juridinis asmuo') }}</span>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-textarea
                    required
                    :label="fizRecipient ? 'Pareigos, vardas ir pavardė' : 'Pavadinimas'"
                    tooltip="Vieša paieška. Paieška. Pareigos vardas ir pavarde arba pavadinimas"
                    v-model="recipient.fullname"
                    validateKey="recipient_fullname_key"
                    :maxlength="200"
                  />
                </v-col>
                <v-col style="display: inline-flex;" class="pb-0" cols="12" md="12" lg="6">
                  <el-text-field
                    required
                    :label="fizRecipient ? 'Asmens kodas' : 'Juridinio asmens kodas'"
                    tooltip="Vieša paieška. Paieška. Asmens arba juridinio asmens kodas"
                    v-model="recipient.code"
                    :length="fizRecipient ? 11 : 9"
                    :cMask="fizRecipient ? 11 : 9"
                    validateKey="recipient_code_key"
                  />
                  <el-button
                  v-if="!fizRecipient"
                  class="ml-1 "
                  style="height: 40px;"
                  :loading="loading"
                  color="primary"
                  title="Ieškoti"
                  @click.native.stop="searchJurData()"
                />
                </v-col>
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-textarea
                    required
                    :label="fizRecipient ? 'Adresas' : 'Buveinės adresas'"
                    tooltip="Vieša paieška. Paieška. Adresas arba buveinės adresas"
                    v-model="recipient.address"
                    validateKey="recipient_address_key"
                    :maxlength="200"
                  />
                </v-col>
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-textarea
                    required
                    label="Pašto kodas, miestas"
                    tooltip="Vieša paieška. Paieška. Pašto kodas ir miestas"
                    v-model="recipient.city"
                    validateKey="recipient_city_key"
                    :maxlength="200"
                  />
                </v-col>
                <v-col class="pt-0" cols="12" md="12">
                  <el-checkbox
                    class="my-0"
                    label="Reikia sąskaitos faktūros"
                    tooltip="Vieša paieška. Paieška. Reikia sąskaitos faktūros"
                    v-model="recipient.invoice_required"
                  >
                  </el-checkbox>
                </v-col>
                <template v-if="recipient.invoice_required">
                  <v-col class="pb-0" cols="12" md="12" lg="6">
                    <el-textarea
                      required
                      label="Pareigos, vardas ir pavardė / Pavadinimas"
                      tooltip="Vieša paieška. Paieška. Reikia sąskaitos faktūros. Pareigos vardas ir pavarde arba pavadinimas"
                      v-model="recipient.invoice_fullname"
                      :maxlength="200"
                    />
                  </v-col>
                  <v-col class="pb-0" cols="12" md="12" lg="6">
                    <el-text-field
                      required
                      label="Asmens / Juridinio asmens kodas"
                      tooltip="Vieša paieška. Paieška. Reikia sąskaitos faktūros. Asmens arba juridinio asmens kodas"
                      v-model="recipient.invoice_code"
                      :cMask="11"
                      validateKey="recipient_invoice_code_key"
                    />
                  </v-col>
                  <v-col class="pb-0" cols="12" md="12" lg="6">
                    <el-textarea
                      required
                      label="Adresas / Buveinės adresas"
                      tooltip="Vieša paieška. Paieška. Reikia sąskaitos faktūros. Adresas arba buveinės adresas"
                      v-model="recipient.invoice_address"
                      validateKey="recipient_invoice_address_key"
                      :maxlength="200"
                    />
                  </v-col>
                  <v-col class="pb-0" cols="12" md="12" lg="6">
                    <el-textarea
                      required
                      label="Pašto kodas, miestas"
                      tooltip="Vieša paieška. Paieška. Reikia sąskaitos faktūros. Pašto kodas ir miestas"
                      v-model="recipient.invoice_city"
                      validateKey="recipient_invoice_city_key"
                      :maxlength="200"
                    />
                  </v-col>
                </template>
                <v-col class="pb-0" cols="12" md="12">
                  <el-text-field
                    required
                    email
                    label="El. paštas"
                    tooltip="Vieša paieška. Paieška. El paštas"
                    v-model="recipient.email_address"
                    :maxlength="100"
                    validateKey="recipient_email_address_key"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col style="display: flex;" class="pb-0" cols="12" md="12">
              <d-recaptcha :loading="loading" title="Užsakyti" @verifyData="searchData" />
              <el-button
                title="Išvalyti"
                color="secondary"
                :loading="loading"
                @click.native="clearData()"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import Enums from '@/enums'
// #RECAPTCHA_OFF
import DRecaptcha from '@/components/recaptcha/DRecaptcha'
import upload from '@/mixins/upload'
import { mapGetters } from 'vuex'

export default {
  name: 'PublicSearchPaidForm',
  mixins: [upload],
  components: {
    // #RECAPTCHA_OFF
    DRecaptcha,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      formData: {},
      recipient: { invoice_required: false },
      dataVolume: null,
      pageloading: false,
      loading: false,
      searchBy: null,
      classifiers: {},
      enumsClassifiers: {},
      files: {},
      uploadedFiles: {},
    }
  },
  computed: {
    ...mapGetters(['getForAccessibility']),
    biggerIltu(){
      return this.$store.getters.getSystemLang == 'en'
    },
    disableITPSI(){
      // dataVolumeOrderSav key
      if(this.dataVolume == "02" && this.formData.parameterType == 'ITPSI'){
         this.$set( this.formData, 'parameterType', 'NTPI')
      }
      return this.dataVolume == "02"
    },
    disableITPSP(){
      if(this.dataVolume == "03" && this.formData.parameterType == 'ITPSP'){
         this.$set( this.formData, 'parameterType', 'NTPI')
      }
      return this.dataVolume == "03"
    },
    fizRecipient(){
      return this.recipient.person_type == "FIZ"
    },
    showSearchTypeCode() {
      return this.formData.searchType === 'ak'
    },
    showSearchTypeIltuCode() {
      return this.formData.searchType === 'iltu'
    },
    showSearchTypedateAnd() {
      return this.formData.searchType === 'birth-date-and-country'
    },
    showParameterTypeItpsi() {
      if(this.formData.parameterType === 'ITPSI'){
        this.$set(this.formData, 'notarial_code', "")
        return true
      }
      return false
    },
    showParameterTypeItpsp() {
      if(this.formData.parameterType === 'ITPSP'){
        this.$set(this.formData, 'notarial_code', "")
        return true
      }
      return false
    },
    showParameterTypeNtpi() {
      if(this.formData.parameterType === 'NTPI'){
        this.$set(this.formData, 'mandate_code', "")
        return true
      }
      return false
    },
    searchTypeJUR() {
      return [
        {
          label: this.$t('Juridinio asmens kodas'),
          value: 'jar-code',
        },
        {
          label: this.$t('Juridinio asmens kodas ir valstybė'),
          value: 'jar-code-and-country',
        },
      ]
    },
    searchType() {
      return [
        {
          label: this.$t('Asmens kodas'),
          value: 'ak',
        },
        {
          label: this.$t('ILTU kodas'),
          value: 'iltu',
        },
        {
          label: this.$t('Gimimo data'),
          value: 'birth-date-and-country',
        },
      ]
    },
    parameterType() {
      return [
        {
          label: this.$t(
            'ITPSĮ - Informacinių technologijų priemonėmis sudarytas įgaliojimas'
          ),
          value: 'ITPSI',
          disabled: this.disableITPSI,
          tooltip: "Vieša paieška. Paieška. Informacinių technologijų priemonėmis sudarytas įgaliojimas",
        },
        {
          label: this.$t('NTPĮ - Notarine tvarka patvirtintas įgaliojimas'),
          value: 'NTPI',
          tooltip: "Vieša paieška. Paieška. Notarine tvarka patvirtintas įgaliojimas",
        },
        {
          label: this.$t('Prokūra'),
          value: 'ITPSP',
          disabled: this.disableITPSP,
          tooltip: "Vieša paieška. Paieška. Prokūra",
        },
      ]
    },
    showFizToggle() {
      return true
    },
    showJurToggle() {
      return true
    },
    showDatToggle() {
      return true
    },
    showFiz() {
      return this.searchBy === 'FIZ'
    },
    showJur() {
      return this.searchBy === 'JUR'
    },
    modeReadonly() {
      return false
    },
  },
  beforeDestroy() {},
  created() {
    this.$validator.reset()
    this.getClassifiers()
  },
  methods: {
    searchByChange() {
      this.formData = {}
    },
    getClassifiers() {
      this.loadDefault = true
      this.enumsClassifiers = Enums
      this.$axios
        .get(`countries`)
        .then((res) => {
          this.classifiers.country = res.data.countries
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    addFile(file, name) {
      this.addUploadedFiles(file, name)
    },

    clearFile(event, name) {
      if (name && this.uploadedFiles.hasOwnProperty(name)) {
        delete this.uploadedFiles[name]
      }
    },
    addUploadedFiles(element, name) {
      if (element != null) {
        this.uploadedFiles[name] = element
      }
    },
    clearData(){
      this.loading = true
      this.searchBy = null
      this.formData = {}
      this.files = {}
      this.recipient = { invoice_required: false }
      this.dataVolume = null
      this.verifyData = []
      this.uploadedFiles = {}
      this.$nextTick(() => {
        this.errors.clear()
        this.$set( this.recipient, 'code', '')
        this.$nextTick(() => {
          this.$set( this.recipient, 'code', '')
          this.$validator.reset()
          this.loading = false
        })
      })
    },
    searchJurData(){
      this.loading = true
      let formData = {}
      formData.code = this.recipient.code
      formData.type = 'JUR'
      formData.dataType = 'search_paid'
      formData.lang = this.$store.getters.getSystemLang
      let url = `getJurByAsmCode`
      let personData = {}
      this.$axios
        .post(url, formData)
        .then((res) => {
          this.recipient.fullname = res.data.person.fullname
          if(res.data.person.adr_text){
            let adr = res.data.person.adr_text.split(',')
            this.recipient.address = adr[1]
            this.recipient.city = adr[0]
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        .finally(() => {
            this.loading = false
        })
    },
    searchData(verifyRecaptcha) {
      if(this.getMaxUploadSize(20)){
        return this.$root.$emit('DATA_ERROR_DIRECT_TEXT', this.getMaxUploadSizeMsg(20))
      }
      this.$validator.validateAll().then((res) => {
        if (res && verifyRecaptcha) {
        // if (res) {
          this.loading = true
          let formData = new FormData()

          Object.keys(this.uploadedFiles).map((key) => {
            formData.append(key, this.uploadedFiles[key])
          })
          formData.append('lang', this.$store.getters.getSystemLang)
          formData.append('language', this.formData.docLanguage)
          formData.append('type', this.dataVolume || '')
          formData.append('purpose', this.formData.purpose || '')
          formData.append('legal_basis', this.formData.legal_basic || '')
          formData.append('person_type', this.searchBy || '')
          formData.append('name', this.formData.name || '')
          formData.append('lastname', this.formData.lastname || '')
          formData.append(
            'fullname',
            this.formData.name
              ? `${this.formData.name} ${this.formData.lastname}`
              : ''
          )
          formData.append('person_search_type', this.formData.searchType || '')
          if(this.showSearchTypeIltuCode){
            formData.append('code', this.formData.iltu_code || '')
          } else {
            formData.append('code', this.formData.code || '')
          }
          formData.append('birth_date', this.formData.birth_date || '')
          formData.append('country_code', this.formData.country || '')
          formData.append('mandate_type', this.formData.parameterType || '')
          formData.append('mandate_code', this.formData.mandate_code || '')
          formData.append('notarial_code', this.formData.notarial_code || '')
          formData.append('withdrawal_method', this.formData.withdrawal || '')
          formData.append(
            'recipient',
            this.recipient ? JSON.stringify(this.recipient) : ''
          )
          // #RECAPTCHA_OFF
          formData.append('recaptcha', verifyRecaptcha)

          let url = `public-search/statement`
          this.getId && formData.append('id', this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              if(res.data.message){
               this.$root.$emit('DATA_OK', res.data.message)
               this.clearData()
              }
            })
            .catch((err) => {
              // this.$root.$emit('DATA_ERROR_TEXT', err.response.data.message)
              err.response.data.fields = {
                'code'                  :  this.$t("Kodas"),
                'fullname'              :  this.$t("Pareigos, vardas ir pavardė / Pavadinimas"),
                'lastname'              :  this.$t("Pavardė"),
                'legal_basis'           :  this.$t("Teisinis pagrindas"),
                'mandate_type'          :  this.$t("Įgaliojimo tipas"),
                'name'                  :  this.$t("Vardas"),
                'person_search_type'    :  this.$t("Paieškos tipas"),
                'purpose'               :  this.$t("Duomenų naudojimo tikslas"),
                'recipient.address'     :  this.$t("Adresas / Buveinės adresas"),
                'recipient.city'        :  this.$t("Pašto kodas, miestas"),
                'recipient.code'        :  this.$t("Asmens / Juridinio asmens kodas"),
                'recipient.invoice_address':  this.$t("Adresas / Buveinės adresas"),
                'email_address'         :  this.$t("El. paštas"),
                'recipient.email_address':  this.$t("El. paštas"),
                'recipient.invoice_city':  this.$t("Pašto kodas, miestas"),
                'recipient.invoice_code':  this.$t("Asmens / Juridinio asmens kodas"),
                'recipient.invoice_fullname':  this.$t("Pareigos, vardas ir pavardė / Pavadinimas"),
                'recipient.fullname'    :  this.$t("Pareigos, vardas ir pavardė / Pavadinimas"),
                'type'                  :  this.$t("Tipas"),
                'withdrawal_method'     :  this.$t("Atsiėmimo būdas"),
                'jur_code'              :  this.$t("Juridinio asmens kodas"),
                'notarial_code'         :  this.$t("Įgaliojimo notarinio registro numeris"),
                'birth_date'            :  this.$t("Gimimo data"),
                'fiz_code'              :  this.$t("Asmens kodas"),
                'mandate_code'          :  this.$t("Identifikavimo kodas"),
              }
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-for-disabled{
  color: black !important;
  background-color: #d6d6d6 !important;
}
</style>
